module.exports = __webpack_public_path__ + "media/images/icons/world-icon-d04cf17846c13a58688118311431fb3d.svg";